var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCautionSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11448_131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.999 147.042C105.974 147.042 105.948 147.04 105.922 147.037C105.622 146.995 105.414 146.718 105.456 146.418L125.978 0.471031C126.02 0.171973 126.298 -0.0358343 126.597 0.00515689C126.896 0.0472174 127.105 0.324175 127.063 0.62359L106.54 146.571C106.502 146.844 106.267 147.042 105.999 147.042Z",
    fill: "#A6CBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.324 147.042C147.057 147.042 146.823 146.846 146.783 146.573L142.608 117.887C142.565 117.588 142.772 117.31 143.071 117.267C143.369 117.222 143.649 117.43 143.692 117.73L147.867 146.415C147.91 146.714 147.703 146.993 147.404 147.036C147.377 147.04 147.35 147.042 147.324 147.042Z",
    fill: "#A6CBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.24847 117.809H110.216L126.661 0.547852H20.6935L4.24847 117.809Z",
    fill: "#013D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.15 117.809H37.1822L20.7372 0.547852H126.705L143.15 117.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.15 118.357H37.1821C36.9091 118.357 36.6777 118.156 36.6399 117.885L20.195 0.623423C20.1729 0.466587 20.2199 0.307969 20.324 0.188203C20.4281 0.0687939 20.5785 0 20.7371 0H126.705C126.978 0 127.209 0.201035 127.247 0.471577L143.692 117.733C143.714 117.89 143.667 118.049 143.563 118.168C143.459 118.288 143.309 118.357 143.15 118.357ZM37.6583 117.262H142.521L126.229 1.095H21.3666L37.6583 117.262Z",
    fill: "#A6CBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.665 83.5713L81.2741 21.1619C78.4858 17.4108 72.6707 18.1384 70.8925 22.4609L45.219 84.8703C43.5919 88.8256 46.5001 93.1667 50.7771 93.1667H122.841C127.782 93.1667 130.612 87.5365 127.665 83.5713Z",
    fill: "#A6CBD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4596 80.6924C90.0342 77.595 87.1784 75.084 84.0809 75.084C80.9834 75.084 78.8173 77.595 79.2427 80.6924C79.6681 83.7899 82.524 86.3009 85.6215 86.3009C88.7189 86.3009 90.885 83.7899 90.4596 80.6924Z",
    fill: "#013D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.494 42.3657L80.5777 70.4901H86.3222L84.6001 40.9861C84.4422 38.2814 82.2028 36.1689 79.4936 36.1689C76.2329 36.1689 73.8046 39.1787 74.494 42.3657Z",
    fill: "#013D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.548426 147.095C0.523475 147.095 0.498167 147.093 0.47286 147.09C0.173446 147.048 -0.0361441 146.772 0.00520359 146.472L20.1511 0.472192C20.1928 0.172778 20.4691 -0.0336034 20.7685 0.00453627C21.0679 0.0458839 21.2775 0.322485 21.2362 0.6219L1.09022 146.622C1.05208 146.896 0.817542 147.095 0.548426 147.095Z",
    fill: "#013D5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8599 147.042C40.5908 147.042 40.3559 146.843 40.3181 146.569L20.1946 0.622045C20.1537 0.322275 20.3629 0.0460295 20.6623 0.00468183C20.9603 -0.0341707 21.2383 0.172924 21.2797 0.472338L41.4031 146.42C41.4441 146.719 41.2349 146.996 40.9355 147.037C40.9102 147.04 40.8849 147.042 40.8599 147.042Z",
    fill: "#013D5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11448_131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147.872,
    height: 147.095,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionSign);
export default __webpack_public_path__ + "static/media/caution-sign.67ff2b3cf0a00515d50f99607649865f.svg";
export { ForwardRef as ReactComponent };